import moment from 'moment';
import { toYuan, fenToWan, numberWithCommas } from '../../utils/unit-conversion';
var scale = [
    {
        dataKey: 'category',
        alias: '日期',
    },
    {
        dataKey: 'value',
        alias: '出险次数',
        formatter: function (value) { return value + ' 次'; },
    },
];
export function formatBarData(barData, scaleConfig, reverseOrder) {
    if (scaleConfig === void 0) { scaleConfig = scale; }
    if (reverseOrder === void 0) { reverseOrder = false; }
    if (reverseOrder) {
        barData.sort(function (a, b) {
            return a.value > b.value ? -1 : a.value < b.value ? 1 : 0;
        });
    }
    else {
        barData.sort(function (a, b) {
            return a.value < b.value ? -1 : a.value > b.value ? 1 : 0;
        });
    }
    var DataSet = require('@antv/data-set');
    var dv = new DataSet.View().source(barData);
    return {
        scale: scaleConfig,
        data: dv.rows,
        height: 400,
    };
}
export function transBarOptions(sourceData, scaleConfig, reverseOrder) {
    if (scaleConfig === void 0) { scaleConfig = scale; }
    if (reverseOrder === void 0) { reverseOrder = false; }
    return formatBarData(sourceData, scaleConfig, reverseOrder);
}
export function transChartLineData(rawData, fields) {
    if (fields === void 0) { fields = 'caseCount'; }
    var dataList = [];
    rawData.forEach(function (item) {
        dataList.push({
            xAxis: moment(item.date).format('YYYY-MM-DD'),
            yAxis: item[fields],
        });
    });
    return dataList;
}
export function transChartLine2(sourceData) {
    var DataSet = require('@antv/data-set');
    var dv = new DataSet.View().source(sourceData);
    dv.transform({
        type: 'rename',
        map: {
            paid: '已决金额',
            unpaid: '未决金额',
        },
    }).transform({
        type: 'fold',
        fields: ['已决金额', '未决金额'],
        key: 'date',
        value: 'money',
    });
    var data = dv.rows;
    return data;
}
var timeEfficiencyCatEnum = ['未知', '0-2000', '2001-5000', '5001-10000', '10000+'];
export function formatHistogramData(rawData) {
    var dataList = [];
    rawData.forEach(function (item) {
        dataList.push({
            xAxis: item.amountType >= 0 && item.amountType < timeEfficiencyCatEnum.length
                ? timeEfficiencyCatEnum[item.amountType]
                : '未知',
            yAxis: item.avgTimeCost,
        });
    });
    return dataList;
}
export function formatRMB(amount) {
    var totalAmount = 0;
    if (amount >= 1000000000) {
        // 大于1000w
        totalAmount = fenToWan(amount);
        return numberWithCommas(Math.floor(totalAmount)) + '万';
    }
    else if (amount < 1000000000 && amount >= 10000000) {
        // 大于10w 小于1000万
        totalAmount = fenToWan(amount, 1);
        return numberWithCommas(totalAmount) + '万';
    }
    else {
        totalAmount = toYuan(amount);
        return numberWithCommas(Math.floor(totalAmount));
    }
}
export function formDefaultSearchDate() {
    var endTime = moment().format('YYYY-MM-DD');
    var startTime = moment()
        .subtract(30, 'days')
        .format('YYYY-MM-DD');
    var params = {
        queryStartTime: startTime,
        queryEndTime: endTime,
        date: [startTime, endTime],
    };
    return params;
}
var DAY_OF_SECS = 60 * 60 * 24;
var HOUR_OF_SECS = 60 * 60;
var MIN_OF_SECS = 60;
export function formatTime(secs) {
    var strTime = '';
    var days = Math.floor(secs / DAY_OF_SECS);
    secs -= days * DAY_OF_SECS;
    var hours = Math.floor(secs / HOUR_OF_SECS);
    secs -= hours * HOUR_OF_SECS;
    var minutes = Math.floor(secs / MIN_OF_SECS);
    secs -= minutes * MIN_OF_SECS;
    if (days) {
        strTime += days + '天';
    }
    if (hours || days > 0) {
        strTime += hours + '时';
    }
    if (!days) {
        if (minutes || hours > 0) {
            strTime += minutes + '分';
        }
        if (secs > 0) {
            strTime += secs + '秒';
        }
    }
    return strTime;
}
